import { graphql, useStaticQuery } from "gatsby"
import React from "react"

const useHeaderQuery = () => {
  const queryHeader = useStaticQuery(
    graphql`
      query HEADER_QUERY {
        allContentfulNolHome(sort: { fields: titulo, order: ASC }) {
          edges {
            node {
              node_locale
              logoNosotras {
                file {
                  url
                }
                description
              }
              menuNavegacion1
              menuNavegacion2
              menuNavegacion3
              menuNavegacion4
              menuNavegacion5
              menuNavegacion6
              menuNavegacion7
            }
          }
        }
        allContentfulNolMenuDeNavegacion(sort: { fields: titulo, order: ASC }) {
          nodes {
            node_locale
            enlaceSubMenu {
              enlaceContenidoSubmenu {
                titulo
                slug
                tieneRedireccion
                redireccion
              }
              enlaceTituloSubmenu {
                titulo
                slug
              }
            }
            titulo
          }
        }
      }
    `
  )
  return queryHeader
}

export default useHeaderQuery
